// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"236":"675d56bc","486":"de961d23","907":"0b5a49ea"}[chunkId] + ".js";
};